import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { DevourPlayApi, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

export type TimeFilter = "day" | "week" | "month" | "year" | "all";

interface RedemptionTransactionHistoryItem {
    id: string;
    lootboxName: string;
    prizeName: string;
    prizeValue?: number;
    prizeType: string;
    prizeImage?: string;
    burnedAt: string;
    createdAt: string;
    description: string; // "LootBox Name - Prize Name" format
}

interface RedemptionTransactionHistoryResponse {
    transactions: RedemptionTransactionHistoryItem[];
    pagination: {
        total: number;
        limit: number;
        offset: number;
        hasMore: boolean;
    };
    timeFilter: string;
    startDate: string;
    endDate: string;
}

interface UseGetTransactionHistoryRedemptionsParams {
    timeFilter?: TimeFilter;
    enabled?: boolean;
}

export const useGetTransactionHistoryRedemptions = (
    fullToken: Token | undefined,
    params: UseGetTransactionHistoryRedemptionsParams = {},
): UseQueryResult<RedemptionTransactionHistoryResponse, Error> => {
    const { timeFilter = "all", enabled = true } = params;

    return useQuery({
        queryKey: ["transaction-history-redemptions-v1", fullToken?.token, timeFilter],
        queryFn: async (): Promise<RedemptionTransactionHistoryResponse> => {
            if (!fullToken?.token) {
                throw new Error("Full token is required for redemption transaction history");
            }
            const data = await new DevourPlayApi(getConfig(fullToken)).getDevourplayTransactionHistoryLootboxRedemption({
                timeFilter: timeFilter as any,
            });
            return data as unknown as RedemptionTransactionHistoryResponse;
        },
        enabled: enabled && !!fullToken?.token,
        staleTime: 30 * 1000, // 30 seconds
        refetchOnWindowFocus: false,
    });
};